<template>
<widget :title="title">

	<div class="d-flex justify-content-between">
		<div v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Services')" class="filter-controls">

			<div class="inline-field filter-tabs">
				<field :params="{type:'btn-group',buttons:[
						{text: 'All',value:'all'},
						{text: 'Draft',value:'draft'},
						{text: 'Quote',value:'quote'},
						{text: 'Dispatched',value:'dispatched'},
						{text: 'Incomplete',value:'incomplete'},
						{text: 'Completed',value:'completed'},
						{text: 'Reviewed',value:'reviewed'},
						{text: 'Processing',value: 'processing'},
						{text: 'Invoiced',value:'invoiced'},
						{text: 'Canceled',value:'canceled'},
						{text: 'Archived',value:'archived'},
					],tabStyling:true}" 
					v-model="$store.serviceFilterArchiveValue" 
					v-on:change="statusToggled">
				</field>
			</div>
			
		</div>

		<div v-if="showTotalLabourHours">
			<info-box label="Total Labour Hours" :value="totalServiceManHours"></info-box>
		</div>
	</div>

	<table-list
		:records="mutatedServices"
		:fields="mutatedFields({
			exclude: ['customerCompanyName','estimated_time']
		})"
		:mobile-breakpoint="$store.tableListMobileBreakpoint"
		record-name="Service Job"
		has-edit="/service/{?}/dashboard"
		id-field="slug"
		:hide-record-count='true'
		:clickable-row="true"
		:sortable="true"
		:total-paginated-records="servicesCount"
		edit-button-text="Open">
	</table-list>
</widget>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import InfoBox from "@/components/InfoBox"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServicesListWidget",
	components: {
		Widget,
		Field,
		TableList,
		InfoBox
	},
	mixins: [ServiceMixins],
	props: [
		"title",
		"showTotalLabourHours"
	],
	computed: {
		totalServiceManHours() {
			if (!this.$store.services)
				return 0

			return this.$store.services.reduce((acc,service) => {

				let serviceTotal = 0
				if (service.TimeLog) {

					serviceTotal = service.TimeLog.reduce((serviceAcc,log) => {
						let logTotal = +log.regular_hours + +log.overtime_hours_15x + +log.overtime_hours_2x + +log.overtime_hours_25x

						return serviceAcc + logTotal
					},0)				
					
				}
				return acc + serviceTotal

			},0) +" hrs"
		}
	},
	methods: {
		statusToggled() {
			let vm = this

			this.$emit("fetchServices")
		},
	}
}
</script>